import type { UploadedTemplateFile } from '../types'

export function revokePreviewUrl(file?: UploadedTemplateFile) {
  if (file?.previewUrl?.startsWith('blob:')) {
    URL.revokeObjectURL(file.previewUrl)
  }
}
